module.exports = __webpack_public_path__ + "roboto-italic-webfont-4c71bd4a88468ea62f92e55cb4e33aef.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-italic-webfont.ttf
// module id = 854
// module chunks = 86